<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="mt-3">
    <div class="row">
      <div class="d-flex align-items-center justify-content-start col">
        <span style="margin-right: 1rem">Show</span>
        <b-form-select
          class="form-control"
          style="width: 20%"
          v-model="perPage"
          :options="pageOptions"
          @change="onChangeEntries"
        ></b-form-select>
        <span style="margin-left: 1rem">entries</span>
      </div>
      <div class="d-flex align-items-center justify-content-end col">
        <label for="searchText" class="mx-3">Search: </label>
        <input
          id="searchText"
          type="text"
          v-model="searchText"
          class="form-control w-50"
          @change="getList"
        />
      </div>
    </div>
    <b-table
      class="table table-bordered"
      hover
      responsive
      :fields="fields"
      :items="listContactSubjects"
      :per-page="perPage"
      @sort-changed="sortCompare"
    >
      <template #cell(action)="data">
        <div class="d-flex justify-content-evenly">
          <router-link
            :to="{
              name: 'DetailContactSubject',
              query: { contactSubjectId: data.item.contactSubjectId },
            }"
            class="btn btn-outline-primary"
            >Detail</router-link
          >
        </div>
      </template>
    </b-table>
    <b-pagination
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
      class="my-0"
      aria-controls="my-table"
      @input="changePage"
    ></b-pagination>
  </div>
</template>

<script>
import ContactService from "@/services/api/contact.service";
import List from "./contactSubjectField.json";
import DefaultListViewData from "@/views/defaultListViewData";
export default {
  data() {
    return {
      ...DefaultListViewData,
      isBusy: false,
      listContactSubjects: [],
      fields: List.fields,
    };
  },
  mounted() {
    this.isLoading = true;
    this.getList(this.sort);
  },
  methods: {
    async getList(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage || this.totalItems,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await ContactService.getListContacts(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listContactSubjects = data.contactSubjects.map((s) => {
              return {
                orderNo: s.displayOrder + 1,
                contactSubjectId: s.contactSubjectId,
                subjectTh: s.subjectTh,
                subjectEn: s.subjectEn,
                status: s.status,
              };
            });
            this.listContactSubjects.sort(function (a, b) {
              return -(
                b.orderNo - a.orderNo ||
                b.subjectTh.localeCompare(a.subjectTh) ||
                b.subjectEn.localeCompare(a.subjectEn)
              );
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    sortCompare(e) {
      this.sort = {
        key: e.sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
    changePage() {
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}

::v-deep .table-width {
  max-width: 5rem;
}
</style>
